export default "__VITE_ASSET__zgPu8seu__"